module.exports = __webpack_public_path__ + "static/media/woman-relaxed.c4a9600d.svg";